import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, finalIncludes, trackCheckout } from '../data/offer';
const noMore = ['No more Sunday nights searching for sessions that actually flow', 'No more classes that feel rushed, repetitive, or improvised', 'No more students plateauing because every session feels the same', 'No more weekends spent planning instead of living', 'No more walking into class wishing you had prepared better', 'No more visible improvisation in your cueing that undermines your confidence', 'No more guessing whether your students are actually progressing'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-cream border-t border-silver-light relative overflow-hidden" data-id="element-96" data-mp="qv577njxeeuo">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-97" data-mp="14uwru74y6thn">
        <div className="text-center mb-16" data-id="element-98" data-mp="14tdbkgjakifv">
          <p className="text-olive font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-99" data-mp="zwv7zjzp6q54">
            Your next teaching week
          </p>
          <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-8 leading-tight text-ink" data-id="element-100" data-mp="2c67rin8zji7z">
            Next Monday you can keep building your mindfulness and meditation sessions from
            scratch...
            <br data-id="element-101" data-mp="2m4x729desql2" />
            <span className="text-brand" data-id="element-102" data-mp="2r1xh0vddqdhg">
              Or you can walk into the room with everything ready — starting today.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-cream-light p-8 rounded-2xl border border-silver-light" data-id="element-103" data-mp="2v2zg9c7aqpjf">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-104" data-mp="34t28vbaia1h8">
                <span className="text-gold mt-0.5" aria-hidden="true" data-id="element-105" data-mp="39sf4oljcuivy">
                  ✦
                </span>
                <span className="text-graphite" data-id="element-106" data-mp="3es1jv0iqu97e">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-ink mb-2" data-id="element-107" data-mp="3isboo9usutko">
            Mindfulness &amp; Meditation Teacher Ready doesn&apos;t make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-brand mb-6" data-id="element-108" data-mp="1jm8tbts2bwv7">You&apos;re already a great teacher.</p>
          <p className="text-xl text-graphite mb-16" data-id="element-109" data-mp="1en5tcnqxwgu3">
            What it does is give you the time and tools to make that visible in every class you
            teach.
          </p>
        </div>
        <div className="bg-paper border-2 border-brand/30 rounded-3xl p-8 md:p-12 shadow-[0_20px_50px_-38px_rgba(51,50,45,0.4)]" data-id="element-110" data-mp="1nnu5fcwrw74c">
          <h3 className="text-2xl font-bold text-ink mb-6 text-center border-b border-silver-light pb-6" data-id="element-111" data-mp="1xg04f6lfzot1">
            Everything that&apos;s included:
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-112" data-mp="2bdezaqugsose">
            {finalIncludes.map(item => <div key={item} className="flex items-start gap-3" data-id="element-113" data-mp="h1i5wscgp8up">
                <Check size={18} className="text-brand shrink-0 mt-0.5" aria-hidden="true" data-id="element-114" data-mp="h1rwoi5bzk1g" />
                <span className="text-sm text-graphite" data-id="element-115" data-mp="d1hgydrqlf9e">{item}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-116" data-mp="2y2o8n8jsb3o">
            <div className="mb-8 p-6 bg-cream rounded-xl border border-silver-light italic text-graphite text-lg" data-id="element-117" data-mp="6y30q2c36c83">
              &ldquo;The best time to have this complete teaching library was before your first
              mindfulness and meditation class.
              <br data-id="element-118" data-mp="3u8j5bnfv4y4g" />
              <span className="text-accent-dark font-bold not-italic" data-id="element-119" data-mp="3fdd0v4wf17d8">
                The second best time is today.
              </span>
              &rdquo;
            </div>
            <p className="text-xl font-display font-extrabold text-ink mb-2" data-id="element-120" data-mp="3kad7pi13ae5e">
              Mindfulness &amp; Meditation Teacher Ready
            </p>
            <p className="text-sm text-graphite-light mb-8" data-id="element-121" data-mp="3bazxuo91znk5">
              6 complete systems in 1, containing 150+ ready-to-teach sessions, created to help
              teachers plan less, teach with confidence, and keep every session technically rich and
              professionally structured.
            </p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-xl py-5 md:py-6 px-8 md:px-12 mb-6" data-id="element-122" data-mp="35m8ckqy9enxt">
              {ctaLabel}
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-graphite-light" data-id="element-123" data-mp="2rojo794zgyo0">
              <span data-id="element-124" data-mp="2moyr749dj0dx">7-Day Money-Back Guarantee</span>
              <span data-id="element-125" data-mp="2mqs0krbdfypm">Secure Payment</span>
              <span data-id="element-126" data-mp="2hxgp2cvm6trd">Instant Access</span>
              <span data-id="element-127" data-mp="2hwdx01mk2l9v">Pay in Your Local Currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}